(function () {
  function shopifyImgSize(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.?#]+)(\?|#|$)/, `_${size}$1$2`);
  }

  function buildColorImageMap(variants, colorOptionIndex) {
    const map = {};
    variants.forEach((v) => {
      const color = v.options && v.options[colorOptionIndex];
      if (color && !map[color]) {
        const src = v.featured_image && v.featured_image.src;
        map[color] = src ? shopifyImgSize(src, '200x200_crop_center') : '';
      }
    });
    return map;
  }

  /** Always returns the live variant-selects element (Dawn may swap it out) */
  function getLiveVariantSelects(sectionId) {
    return document.getElementById(`variant-selects-${sectionId}`);
  }

  /** Find the colour fieldset or select inside the current live variant-selects */
  function findColorInput(sectionId) {
    const el = getLiveVariantSelects(sectionId);
    if (!el) return { fieldset: null, select: null };
    let fieldset = null;
    el.querySelectorAll('fieldset').forEach((fs) => {
      const legend = fs.querySelector('legend');
      if (legend && /color/i.test(legend.textContent)) fieldset = fs;
    });
    const select = fieldset ? null : el.querySelector('select[name*="Color"], select[name*="color"]');
    return { fieldset, select };
  }

  /** Hide the native colour picker inside the current live variant-selects */
  function hideNativePicker(sectionId) {
    const { fieldset, select } = findColorInput(sectionId);
    if (fieldset) {
      fieldset.style.display = 'none';
    } else if (select) {
      const wrapper = select.closest('.product-form__input') || select.parentElement;
      if (wrapper) wrapper.style.display = 'none';
    }
  }

  /** Get the currently selected colour from the live picker */
  function getActiveColor(sectionId) {
    const { fieldset, select } = findColorInput(sectionId);
    if (fieldset) {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    }
    if (select) return select.value || null;
    return null;
  }

  function initProductSwatches(sectionId, product) {
    const colorImageMap = buildColorImageMap(product.variants, product.color_option_index);
    if (!Object.keys(colorImageMap).length) return;

    // Collect all colour values from the product JSON (stable — never changes)
    const allColors = [];
    const seen = new Set();
    product.variants.forEach((v) => {
      const color = v.options && v.options[product.color_option_index];
      if (color && !seen.has(color)) { seen.add(color); allColors.push(color); }
    });
    if (!allColors.length) return;

    // Remove any existing wrapper from a previous init
    const existingWrapper = document.getElementById(`image-swatches-wrapper-${sectionId}`);
    if (existingWrapper) existingWrapper.remove();

    const variantSelectsEl = getLiveVariantSelects(sectionId);
    if (!variantSelectsEl) return;

    // ── Build the swatch UI ──────────────────────────────────────────────────
    const currentColor = getActiveColor(sectionId) || allColors[0];

    const wrapper = document.createElement('div');
    wrapper.className = 'image-swatches-wrapper';
    wrapper.id = `image-swatches-wrapper-${sectionId}`;
    wrapper.innerHTML = `
      <label class="form__label image-swatches__label">
        Color: <span class="image-swatches__name" data-product-swatch-name></span>
      </label>
      <div class="image-swatches" data-product-swatches></div>`;

    const nameEl  = wrapper.querySelector('[data-product-swatch-name]');
    const swatchesEl = wrapper.querySelector('[data-product-swatches]');
    nameEl.textContent = currentColor;

    allColors.forEach((color) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'image-swatch' + (color === currentColor ? ' image-swatch--selected' : '');
      btn.setAttribute('aria-label', color);
      btn.setAttribute('title', color);
      btn.dataset.color = color;
      const img = colorImageMap[color];
      if (img) btn.style.backgroundImage = `url('${img}')`;

      btn.addEventListener('click', () => {
        // Always read the LIVE element — Dawn may have swapped it since we ran
        const { fieldset, select } = findColorInput(sectionId);

        swatchesEl.querySelectorAll('.image-swatch').forEach((s) => s.classList.remove('image-swatch--selected'));
        btn.classList.add('image-swatch--selected');
        nameEl.textContent = color;

        // ── 1. Fire native variant change (updates price, availability, URL) ──
        if (fieldset) {
          const radio = fieldset.querySelector(`input[value="${CSS.escape(color)}"]`);
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else if (select) {
          select.value = color;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // ── 2. Directly switch the gallery image ────────────────────────────
        const matchingVariant = product.variants.find(
          (v) => v.options && v.options[product.color_option_index] === color
        );
        if (matchingVariant && matchingVariant.featured_image && product.media && product.media.length) {
          const gallery = document.querySelector(`#MainProduct-${sectionId} media-gallery`);
          if (gallery && typeof gallery.setActiveMedia === 'function') {

            // Normalise CDN URL → base filename without size suffix or query string
            const normSrc = (src) => {
              if (!src) return '';
              return src.split('?')[0].split('/').pop()
                .replace(/_\d+x\d*(_crop_\w+)?(\.[^.]+)$/, '$2');
            };

            const targetBase = normSrc(matchingVariant.featured_image.src);

            // Find the media object whose preview src matches the variant's featured image
            const matchedMedia = product.media.find(
              (m) => normSrc(m.src) === targetBase
            );

            if (matchedMedia) {
              // data-media-id = "sectionId-mediaId"
              const compoundId = `${sectionId}-${matchedMedia.id}`;
              gallery.setActiveMedia(compoundId, true);
            }
          }
        }
      });

      swatchesEl.appendChild(btn);
    });

    // ── Insert BEFORE variant-selects (outside Dawn's replacement zone) ─────
    variantSelectsEl.insertAdjacentElement('beforebegin', wrapper);
    hideNativePicker(sectionId);

    // ── Watch the PARENT for Dawn swapping in a brand-new variant-selects ───
    // Dawn does: parent.insertBefore(newVariantSelects, oldVariantSelects)
    // then removes the old one. We observe childList on the parent.
    const parent = variantSelectsEl.parentNode;
    if (!parent) return;

    // Disconnect any previous observer stored on the parent
    if (parent._imageSwatchObserver) {
      parent._imageSwatchObserver.disconnect();
    }

    const parentObserver = new MutationObserver((mutations) => {
      let newVariantSelects = null;
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.tagName && node.tagName.toLowerCase() === 'variant-selects') {
            newVariantSelects = node;
          }
        });
      });
      if (!newVariantSelects) return;

      // Dawn just inserted a fresh variant-selects — re-hide native picker
      hideNativePicker(sectionId);

      // Sync swatch highlight to what Dawn selected
      const active = getActiveColor(sectionId);
      if (active) {
        swatchesEl.querySelectorAll('.image-swatch').forEach((s) => {
          s.classList.toggle('image-swatch--selected', s.dataset.color === active);
        });
        nameEl.textContent = active;
      }
    });

    parentObserver.observe(parent, { childList: true });
    parent._imageSwatchObserver = parentObserver;
  }

  function init() {
    document.querySelectorAll('[id^="QuoteProductData-"]').forEach((el) => {
      const sectionId = el.id.replace('QuoteProductData-', '');
      try {
        const product = JSON.parse(el.textContent);
        initProductSwatches(sectionId, product);
      } catch (e) {
        console.warn('image-swatches init error:', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
